import React, { useEffect, useRef } from "react";
import { Grid, TextField, Button, Typography, Box } from "@mui/material";
import { UserInput } from "../../models/testSteps/userInput.ts";
import { ImageBox } from "../../components/ImageBox.tsx";

interface Props {
  data: UserInput;
  onChange: (updated: UserInput) => void;
  setIsValid: (valid: boolean) => void;
}

const EditUserInputForm: React.FC<Props> = ({ data, onChange, setIsValid }) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    setIsValid(data.name.trim() !== "" && data.text.trim() !== "");
  }, [data, setIsValid]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = (reader.result as string).split(",")[1];
        onChange({
          ...data,
          image_path: file.name,
          image_data: base64,
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    onChange({
      ...data,
      image_path: "",
      image_data: "",
    });
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  return (
    <Grid container spacing={2} mt={1}>
      <Grid size={12}>
        <TextField
          label="Name"
          fullWidth
          value={data.name}
          onChange={(e) => onChange({ ...data, name: e.target.value })}
        />
      </Grid>
      <Grid size={12}>
        <TextField
          label='Frage, die mit "Fail" oder "Pass" beantwortet werden kann'
          multiline
          rows={3}
          fullWidth
          value={data.text}
          onChange={(e) => onChange({ ...data, text: e.target.value })}
        />
      </Grid>
      <Grid size={12}>
        <Box display="flex" alignItems="center" gap={2}>
          <Button variant="outlined" component="label">
            Bild auswählen
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={handleFileChange}
              ref={fileInputRef}
            />
          </Button>
          {data.image_path && (
            <>
              <Typography>{data.image_path}</Typography>
              <Button color="error" onClick={handleRemoveImage}>
                Entfernen
              </Button>
            </>
          )}
        </Box>
        {data.image_data && (
          <ImageBox
              src={`data:image/*;base64,${data.image_data}`}
              alt="Vorschau"
              height={200}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default EditUserInputForm;
